import React from "react";
import { Link } from "react-router-dom";
import Icon1 from "../Assets/img/feature/feature-1.svg";
import Icon2 from "../Assets/img/feature/feature-2.svg";
import Icon3 from "../Assets/img/feature/feature-3.svg";
import Icon4 from "../Assets/img/feature/feature-4.svg";
import Icon5 from "../Assets/img/feature/feature-5.svg";
import Icon6 from "../Assets/img/feature/feature-6.svg";
import Icon7 from "../Assets/img/feature/feature-7.svg";
import Icon8 from "../Assets/img/feature/feature-8.svg";
import Icon9 from "../Assets/img/feature/feature-9.svg";
import Icon10 from "../Assets/img/feature/feature-10.svg";
import Icon11 from "../Assets/img/feature/feature-11.svg";
import Icon12 from "../Assets/img/feature/feature-12.svg";
import Icon13 from "../Assets/img/feature/feature-13.svg";
import Icon14 from "../Assets/img/feature/feature-14.svg";
import Icon15 from "../Assets/img/feature/feature-15.svg";
import Icon16 from "../Assets/img/feature/feature-16.svg";
import Icon17 from "../Assets/img/feature/feature-17.svg";
import Icon18 from "../Assets/img/feature/feature-18.svg";
import Icon19 from "../Assets/img/feature/feature-19.svg";
import Icon20 from "../Assets/img/feature/feature-20.svg";
import Icon21 from "../Assets/img/feature/feature-21.svg";
import Icon22 from "../Assets/img/feature/feature-22.svg";
import Icon23 from "../Assets/img/feature/feature-23.svg";
import Icon24 from "../Assets/img/feature/feature-24.svg";
import Icon25 from "../Assets/img/feature/feature-25.svg";
const CoreFeatures = () => {
  const CoreFeaturesCard = [
    {
      id: "item1",
      icon: Icon1,
      title: "Multiple Branch Management",
    },
    {
      id: "item2",
      icon: Icon2,
      title: "Client Management",
    },
    {
      id: "item3",
      icon: Icon3,
      title: "Billing Management",
    },
    {
      id: "item4",
      icon: Icon4,
      title: "HR & Payroll",
    },
    {
      id: "item5",
      icon: Icon5,
      title: "Support & Ticketing",
    },
    {
      id: "item6",
      icon: Icon6,
      title: "Task Management",
    },
    {
      id: "item7",
      icon: Icon7,
      title: "Purchase Management",
    },
    {
      id: "item8",
      icon: Icon8,
      title: "Inventory Management",
    },
    {
      id: "item9",
      icon: Icon9,
      title: "Network Diagram",
    },
    {
      id: "item10",
      icon: Icon10,
      title: "Accounts Management",
    },
    {
      id: "item11",
      icon: Icon11,
      title: "Asset Management",
    },
    {
      id: "item12",
      icon: Icon12,
      title: "Bandwidth Purchase",
    },
    {
      id: "item13",
      icon: Icon13,
      title: "Bandwidth Sales",
    },
    {
      id: "item14",
      icon: Icon14,
      title: "Bandwidth Reseller Portal",
    },
    {
      id: "item15",
      icon: Icon15,
      title: "MAC Reseller Portal",
    },
    {
      id: "item16",
      icon: Icon16,
      title: "Admin Portal (Web & APP)",
    },
    {
      id: "item17",
      icon: Icon17,
      title: "Employee Portal (Web/APP)",
    },
    {
      id: "item18",
      icon: Icon18,
      title: "Client Portal (Web & App)",
    },
    {
      id: "item19",
      icon: Icon19,
      title: "BTRC Report",
    },
    {
      id: "item20",
      icon: Icon20,
      title: "Mikrotik Integration",
    },
    {
      id: "item21",
      icon: Icon21,
      title: "Informative Dashboard",
    },
    {
      id: "item22",
      icon: Icon22,
      title: "Business Configuration",
    },
    {
      id: "item23",
      icon: Icon23,
      title: "Online Payment Gateway",
    },
    {
      id: "item24",
      icon: Icon24,
      title: "Bulk SMS & Mailing System",
    },
    {
      id: "item25",
      icon: Icon25,
      title: "Role Based Permission",
    },
  ];

  return (
    <>
      <section className="feature-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Core Features</h3>
                <p>
                  Your business is your brain, so let us take care. These
                  features make your business a hundred times easier.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* <!-- Menu Tab --> */}
              <div className="menu-tab nav nav-tabs" data-toggle="tab-second">
                <div className="row">
                  {CoreFeaturesCard.map((singleCard) => (
                    <div
                      className="col-lg-4 col-md-6 col-12"
                      key={singleCard.id}
                    >
                      <div className="nav-item">
                        <Link to="#">
                          <div className="single-feature">
                            <ul>
                              <li className="feature-img">
                                <img src={singleCard.icon} alt="#" />
                              </li>
                              <li>{singleCard.title}</li>
                            </ul>
                          </div>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-btn">
                <Link to="#" className="theme-btn">
                  Explore features
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoreFeatures;
